import type { OAuthFlowTypeEnum } from '@/lib/app.model'

export enum AuthFlowPayloadIntent {
	LOGIN = 'LOGIN',
	SIGNUP = 'SIGNUP',
}

export interface AuthFlowPayload {
	type: OAuthFlowTypeEnum
	intent?: AuthFlowPayloadIntent
	permissions: string[]
	applicationId?: string
	providerId?: string
	redirectUrl?: string
	socialAuthRedirectUrl?: string
	code?: string
	serviceName?: string
	userAccountId?: string
	referralId?: string
	ssoToken?: string
	protocol?: string
}

export interface State {
	authReady: boolean
	authToken: string
	refreshToken: string
	userId: string
	currentSessionId: string
	profiles: unknown[]
	profileLoading: boolean
	accountRecoverCredentialsId: string
	accountRecoverLoginId: string
	credentials: unknown[]
	currentCredentialsId: string
	authFlowPayload: AuthFlowPayload
	authFlowWithProvider: boolean
	pendingAccountConfirmation: boolean
	sessions: unknown[]
	refreshDeadline: string
}
